'use client'

import type { SKUSelectorProps } from './SKUSelectorProps'

export const SKUSelectorDefaults = {
  previewAllItems: true,
  options: [
    {
      isDropdown: true,
      content: [
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          id: 'builder-ba5f81319250407d90021fe94619a52a',
          component: {
            name: 'Text',
            options: { text: '<p>SKU1 Content</p>' },
          },
        },
      ],
      sku: '',
      dropdownOptions: [
        {
          content: [
            {
              '@type': '@builder.io/sdk:Element',
              '@version': 2,
              id: 'builder-08493f456cbd424290258f9f4ac13819',
              meta: {
                previousId: 'builder-44ae1b00d2b048608692826903aee541',
              },
              children: [
                {
                  '@type': '@builder.io/sdk:Element',
                  '@version': 2,
                  id: 'builder-afa442616db340bea3e7c2f6b3be3c08',
                  meta: {
                    'transformed.text': 'localized',
                    localizedTextInputs: ['text'],
                  },
                  component: {
                    name: 'Text',
                    options: {
                      getValueFromCountdown: false,
                      style: 'Body MD - Medium weight',
                      actionName: 'none',
                      navigate: {
                        href: '/',
                        analyticsEvent: 'none',
                      },
                      text: 'Subscription**',
                    },
                  },
                  responsiveStyles: {
                    large: {
                      position: 'relative',
                      height: 'auto',
                      textAlign: 'center',
                      marginRight: 'auto',
                    },
                  },
                },
                {
                  '@type': '@builder.io/sdk:Element',
                  '@version': 2,
                  id: 'builder-11794be17a8c414c97fe70c866575e8b',
                  children: [
                    {
                      '@type': '@builder.io/sdk:Element',
                      '@version': 2,
                      id: 'builder-f83b697803c643d380f477f56bc3883b',
                      meta: {
                        'transformed.text': 'localized',
                        localizedTextInputs: ['text'],
                      },
                      component: {
                        name: 'Text',
                        options: {
                          getValueFromCountdown: false,
                          style: 'Body MD - Medium weight',
                          actionName: 'none',
                          navigate: {
                            href: '/',
                            analyticsEvent: 'none',
                          },
                          text: '<p><s>$179</s> <span style="color: rgb(208, 2, 27);">$119/yr (72% off)</span></p>',
                        },
                      },
                      responsiveStyles: {
                        large: {
                          position: 'relative',
                          height: 'auto',
                          textAlign: 'center',
                          marginLeft: 'auto',
                        },
                        small: { textAlign: 'right' },
                      },
                    },
                    {
                      '@type': '@builder.io/sdk:Element',
                      '@version': 2,
                      id: 'builder-69a6c15b926b4cc8bb6f45cbf6796e5a',
                      meta: {
                        'transformed.text': 'localized',
                        localizedTextInputs: ['text'],
                      },
                      component: {
                        name: 'Text',
                        options: {
                          getValueFromCountdown: false,
                          style: 'Body XS',
                          actionName: 'none',
                          navigate: {
                            href: '/',
                            analyticsEvent: 'none',
                          },
                          text: "<p>That's only $9.92 per month! 👆</p>",
                        },
                      },
                      responsiveStyles: {
                        large: {
                          position: 'relative',
                          height: 'auto',
                          textAlign: 'center',
                          marginLeft: 'auto',
                          display: 'flex',
                        },
                        medium: { display: 'flex' },
                        small: {
                          textAlign: 'right',
                          display: 'none',
                        },
                      },
                    },
                  ],
                  responsiveStyles: {
                    large: { position: 'relative' },
                  },
                },
              ],
              responsiveStyles: {
                large: {
                  position: 'relative',
                  display: 'flex',
                  marginBottom: '0.5em',
                },
              },
            },
            {
              '@type': '@builder.io/sdk:Element',
              '@version': 2,
              id: 'builder-b4b0de21167944ffadb78412c529b6cb',
              meta: {
                'transformed.text': 'localized',
                localizedTextInputs: ['text'],
              },
              component: {
                name: 'Text',
                options: {
                  getValueFromCountdown: false,
                  style: 'Body SM',
                  actionName: 'none',
                  navigate: {
                    href: '/',
                    analyticsEvent: 'none',
                  },
                  text: '<p>New Customers** get 72% off the Monthly Plan! $119 billed today for the first year, then billed annually at $179*.</p>',
                },
              },
              responsiveStyles: {
                large: {
                  position: 'relative',
                  height: 'auto',
                  textAlign: 'left',
                  marginRight: 'auto',
                  marginBottom: '0.5em',
                },
              },
            },
            {
              '@type': '@builder.io/sdk:Element',
              '@version': 2,
              id: 'builder-afb0f83256624f6684392efcfd528c31',
              component: {
                name: 'Columns',
                options: {
                  columns: [
                    {
                      blocks: [
                        {
                          '@type': '@builder.io/sdk:Element',
                          '@version': 2,
                          id: 'builder-0089e6514b2a45da98c75cf1616a9bfa',
                          meta: {
                            previousId: 'builder-5cbeab9e31e84a6c94ade5aca3edf20f',
                            'transformed.items.0.value': 'localized',
                            'transformed.items.1.value': 'localized',
                          },
                          component: {
                            name: 'Checklist',
                            options: {
                              textStyle: 'Body SM',
                              items: [
                                {
                                  value: '<p>Access to 21 Day Fix Program.</p>',
                                },
                                {
                                  value:
                                    '<p>1000s of workouts including cardio, weightlifting and yoga </p>',
                                },
                              ],
                              checkColor: 'var(--color-bodi-accent-deep-500)',
                              checkIcon: 'CheckIcon',
                              iconType: 'solid',
                              iconSize: 16,
                              separation: 8,
                            },
                          },
                          responsiveStyles: {
                            large: { position: 'relative' },
                          },
                        },
                      ],
                    },
                    {
                      blocks: [
                        {
                          '@type': '@builder.io/sdk:Element',
                          '@version': 2,
                          id: 'builder-fad98b72062b4681bf63f28b1dfb3eb2',
                          meta: {
                            previousId: 'builder-000d69530ee741e29c26de14100949ac',
                            'transformed.items.1.value': 'localized',
                            'transformed.items.0.value': 'localized',
                          },
                          component: {
                            name: 'Checklist',
                            options: {
                              textStyle: 'Body SM',
                              items: [
                                {
                                  value: '<p>130+ fitness programs included.</p>',
                                },
                                {
                                  value: '<p>All BODi Super Trainers</p>',
                                },
                              ],
                              checkColor: 'var(--color-bodi-accent-deep-500)',
                              checkIcon: 'CheckIcon',
                              iconType: 'solid',
                              iconSize: 16,
                              separation: 8,
                            },
                          },
                          responsiveStyles: {
                            large: { position: 'relative' },
                          },
                        },
                      ],
                    },
                  ],
                  space: 20,
                  stackColumnsAt: 'tablet',
                  reverseColumnsWhenStacked: false,
                },
              },
              responsiveStyles: {
                large: { position: 'relative' },
              },
            },
          ],
          sku: 'BBUSBODINCNT325',
          label: 'Billed Anually (Most Popular)',
        },
        {
          content: [
            {
              '@type': '@builder.io/sdk:Element',
              '@version': 2,
              id: 'builder-568614b0a2fc49d186987b67e73da50e',
              meta: {
                previousId: 'builder-08493f456cbd424290258f9f4ac13819',
              },
              children: [
                {
                  '@type': '@builder.io/sdk:Element',
                  '@version': 2,
                  id: 'builder-fa26264944244041868f14607e62aeae',
                  meta: {
                    previousId: 'builder-afa442616db340bea3e7c2f6b3be3c08',
                  },
                  component: {
                    name: 'Text',
                    options: {
                      text: 'Subscription**',
                      getValueFromCountdown: false,
                      style: 'Body MD - Medium weight',
                      actionName: 'none',
                      navigate: {
                        href: '/',
                        analyticsEvent: 'none',
                      },
                    },
                  },
                  responsiveStyles: {
                    large: {
                      position: 'relative',
                      height: 'auto',
                      textAlign: 'center',
                      marginRight: 'auto',
                    },
                  },
                },
                {
                  '@type': '@builder.io/sdk:Element',
                  '@version': 2,
                  id: 'builder-e177465c7b824116baee7f3a8f27fe15',
                  meta: {
                    previousId: 'builder-11794be17a8c414c97fe70c866575e8b',
                  },
                  responsiveStyles: {
                    large: { position: 'relative' },
                  },
                },
                {
                  '@type': '@builder.io/sdk:Element',
                  '@version': 2,
                  id: 'builder-37fcff30c5ba4313b3e90447cf3392bc',
                  meta: {
                    previousId: 'builder-815aa51d120843de9adc5ccdf14e5d86',
                  },
                  component: {
                    name: 'Text',
                    options: {
                      text: '<p>$59.95/mo</p>',
                      getValueFromCountdown: false,
                      style: 'Body MD - Medium weight',
                      actionName: 'none',
                      navigate: {
                        href: '/',
                        analyticsEvent: 'none',
                      },
                    },
                  },
                  responsiveStyles: {
                    large: {
                      position: 'relative',
                      height: 'auto',
                      textAlign: 'center',
                      marginLeft: 'auto',
                    },
                  },
                },
              ],
              responsiveStyles: {
                large: {
                  position: 'relative',
                  display: 'flex',
                  marginBottom: '0.5em',
                },
              },
            },
            {
              '@type': '@builder.io/sdk:Element',
              '@version': 2,
              id: 'builder-c7921e2cc30a43648c2b216decbdf7dd',
              meta: {
                previousId: 'builder-afb0f83256624f6684392efcfd528c31',
              },
              component: {
                name: 'Columns',
                options: {
                  columns: [
                    {
                      blocks: [
                        {
                          '@type': '@builder.io/sdk:Element',
                          '@version': 2,
                          id: 'builder-fef73ebc8fcf41d193fae27de5a78fd4',
                          meta: {
                            previousId: 'builder-5cbeab9e31e84a6c94ade5aca3edf20f',
                          },
                          component: {
                            name: 'Checklist',
                            options: {
                              textStyle: 'Body SM',
                              items: [
                                {
                                  value: '<p>Access to 21 Day Fix Program.</p>',
                                },
                                {
                                  value:
                                    '<p>1000s of workouts including cardio, weightlifting and yoga </p>',
                                },
                              ],
                              checkColor: 'var(--color-bodi-accent-deep-500)',
                              checkIcon: 'CheckIcon',
                              iconType: 'solid',
                              iconSize: 16,
                              separation: 8,
                            },
                          },
                          responsiveStyles: {
                            large: { position: 'relative' },
                          },
                        },
                      ],
                    },
                    {
                      blocks: [
                        {
                          '@type': '@builder.io/sdk:Element',
                          '@version': 2,
                          id: 'builder-ba7cf9dfe3ec4925a193bf5444f94789',
                          meta: {
                            previousId: 'builder-000d69530ee741e29c26de14100949ac',
                          },
                          component: {
                            name: 'Checklist',
                            options: {
                              textStyle: 'Body SM',
                              items: [
                                {
                                  value: '<p>130+ fitness programs included.</p>',
                                },
                                {
                                  value: '<p>All BODi Super Trainers</p>',
                                },
                              ],
                              checkColor: 'var(--color-bodi-accent-deep-500)',
                              checkIcon: 'CheckIcon',
                              iconType: 'solid',
                              iconSize: 16,
                              separation: 8,
                            },
                          },
                          responsiveStyles: {
                            large: { position: 'relative' },
                          },
                        },
                      ],
                    },
                  ],
                  space: 20,
                  stackColumnsAt: 'tablet',
                  reverseColumnsWhenStacked: false,
                },
              },
              responsiveStyles: {
                large: { position: 'relative' },
              },
            },
          ],
          sku: 'BBUSBODINCNT308',
          label: 'Billed Monthly',
        },
      ],
    },
    {
      isDropdown: false,
      content: [
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          id: 'builder-44ae1b00d2b048608692826903aee541',
          children: [
            {
              '@type': '@builder.io/sdk:Element',
              '@version': 2,
              id: 'builder-171a703481ba4f2d94e853f6d77fc538',
              meta: {
                previousId: 'builder-dbdac495fd4149ecaf7f7edb4783b451',
                'transformed.text': 'localized',
                localizedTextInputs: ['text'],
              },
              component: {
                name: 'Text',
                options: {
                  style: 'Body MD - Medium weight',
                  text: '<p>Buy and own access forever - no subscription needed</p>',
                },
              },
              responsiveStyles: {
                large: { marginRight: 'auto' },
              },
            },
            {
              '@type': '@builder.io/sdk:Element',
              '@version': 2,
              id: 'builder-929f8940d5174a958007238682f910d3',
              meta: {
                'transformed.text': 'localized',
                localizedTextInputs: ['text'],
              },
              component: {
                name: 'Text',
                options: {
                  getValueFromCountdown: false,
                  style: 'Body MD - Medium weight',
                  actionName: 'none',
                  navigate: {
                    href: '/',
                    analyticsEvent: 'none',
                  },
                  text: '<p>$59.95</p>',
                },
              },
              responsiveStyles: {
                large: {
                  position: 'relative',
                  height: 'auto',
                  textAlign: 'right',
                  marginLeft: 'auto',
                },
              },
            },
          ],
          responsiveStyles: {
            large: { position: 'relative', display: 'flex' },
          },
        },
      ],
      sku: 'BBUS21DFSTREAM',
      dropdownOptions: [
        {
          content: [
            {
              '@type': '@builder.io/sdk:Element',
              '@version': 2,
              id: 'builder-bd6c0e5700804f07be484a379a5208e4',
              component: {
                name: 'Text',
                options: { text: 'SKU Dropdown Content' },
              },
            },
          ],
        },
      ],
    },
  ],
  addToCartContent: [
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      id: 'builder-ba5f81319250407d90021fe94619a52a',
      component: {
        name: 'Text',
        options: { text: 'Get Offer' },
      },
    },
  ],
  addToCartVariant: 'primary',
  redirectUrl: '/cart',
} as unknown as SKUSelectorProps
